module.exports = __webpack_public_path__ + "static/media/lasensacion.bc741b96.jpg";